import { GlyphType, ListItemInfo } from "types/Paragraph";

export const useCreateListItemString = (listItemInfo: ListItemInfo) => {
  var value = "";

  if (listItemInfo.glyphSymbol) {
    value = listItemInfo.glyphSymbol;
  } else {
    var counter = listItemInfo.counter;

    switch (listItemInfo.glyphType) {
      case "BULLET":
        value = "•";
        break;
      case "HOLLOW_BULLET":
        value = "○";
        break;
      case "SQUARE_BULLET":
        value = "□";
        break;
      case "DECIMAL":
        value = counter?.toString() ?? "";
        break;
      case "UPPER_ROMAN":
        value = useNumberToRomanNumeral(counter).toUpperCase();
        break;
      case "ROMAN":
        value = useNumberToRomanNumeral(counter).toLowerCase();
        break;
      case "ALPHA":
        value = useNumberToAlpha(counter, false);
        break;
      case "SYMBOL":
        value = "*"; // You can modify this as per the required symbol
        break;
      case "UPPER_ALPHA":
        value = counter <= 26 ? useNumberToAlpha(counter) : counter?.toString() ?? "";
        break;
      case "NUMBERED_DISC":
        value = counter + "•";
        break;
      case "NUMBERED_CIRCLE":
        value = counter + "○";
        break;
      case "NUMBERED_SQUARE":
        value = counter + "□";
        break;
      default:
        value = counter != undefined ? counter.toString() : "";
        break;
    }
  }

  if (listItemInfo.glyphFormat) {
    return listItemInfo.glyphFormat.replace(/%[0-9]/, value);
  }

  return value;
};
